import { hasPermissionByIds } from '@gef-ui/cdu-user/selectors';

import { codelists } from 'constants/codelists';
import { KCL_DOCUMENT_CHECK_ADMINS } from 'features/common/acl/constants';
import fetch from 'features/common/fetch';

import { setFinalStates, setProductionControlDetail } from './slice';

const { documentCheckFinalStateAdmin, documentCheckFinalState } = codelists;

export const fetchDocumentDetail = (documentId) => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.koprDetail, {
			replaceParams: { documentId },
			onSuccess: [
				(response) => () => {
					if (!response || !response.body) return;
					const body = response?.body;
					dispatch(setProductionControlDetail(body));
				},
			],
		}),
	);
};

export const fetchFinalStates = () => (dispatch, getState) => {
	const userIsCentral = hasPermissionByIds(getState())(KCL_DOCUMENT_CHECK_ADMINS);

	dispatch(
		fetch.actions.get(fetch.constants.urls.codeTable, {
			replaceParams: { storeKey: userIsCentral ? documentCheckFinalStateAdmin : documentCheckFinalState },
			onSuccess: [
				(response) => () => {
					if (!response || !response.body) return;
					const body = response?.body;
					dispatch(setFinalStates(body?.values));
				},
			],
		}),
	);
};
